import React from 'react';
import algoliaAnalytics from 'search-insights';

import { QtySelect } from 'src/components/Forms/QtySelect';
import { Button } from 'src/components/Button/Button';
import { Svg } from 'src/components/Svg/Svg';
import { QtyInput } from 'src/components/Forms/QtyInput';

import classes from './ProductActions.scss';

export function ProductActions() {
    return (
        <div className={classes.cta}>
            <div className={classes.qtyInput}>
                <QtyInput id="product">
                    <QtySelect id="product" field="qty" initialValue={1} />
                </QtyInput>
            </div>
            <div className={classes.addToCart}>
                <Button
                    data-test-id="product-add"
                    type="submit"
                    icon="left-of-text"
                    width="full"
                    aria-label="Add to Basket"
                    aria-live="polite"
                    onClick={() => {
                        /**
                         * Algolia convertion data needed for event:
                         * index: "indexName",
                         * eventName: 'Product added to cart',
                         * userToken: 'user-1',
                         * objectIDs: [objectID],
                         * queryID: queryId
                         */
                        const queryString = (window as any).location.search;

                        if (!queryString) return;

                        const urlParams = new URLSearchParams(queryString);
                        const queryId = urlParams.get('queryId');
                        const objectID = urlParams.get('objectId');
                        const indexName = urlParams.get('indexName');

                        if (indexName) {
                            algoliaAnalytics('convertedObjectIDsAfterSearch', {
                                index: indexName!,
                                eventName: `Product added to cart'`,
                                objectIDs: [objectID!],
                                queryID: queryId!,
                            });
                        }
                    }}
                >
                    <Svg name="basket" />
                    <span>Add to Cart</span>
                </Button>
            </div>
        </div>
    );
}
